import { RouterLocation } from 'connected-react-router'
import { Callback } from 'Src/types/utilTypes'
import { AppDispatch, AppState } from '.'

export type InferActionsType<T> = T extends { [keys: string]: (...args: unknown[]) => infer U }
	? U
	: never

export type RemoveUpperTypes<
	T extends string,
	X = {
		[Key in T]: Uppercase<Key> extends Key ? never : Key
	}
> = X[keyof X]

// Use with import * as ... from actions
export type InferActionsWithOutUpper<T extends { [key: string]: Callback }> = InferActionsType<
	Pick<T, keyof T extends string ? RemoveUpperTypes<keyof T> : never>
>

export function createAction<T extends (...args: unknown[]) => ReturnType<T>>(
	dispatch: AppDispatch,
	action: T
) {
	return (...args: Parameters<T>) => {
		dispatch(action(...args))
	}
}

// Use only in saga, for components use react-router hooks: useHistory, useLocation, etc.
export const selectHistory = <T = unknown>(state: AppState) => ({
	location: state.router.location as RouterLocation<T>,
	action: state.router.action,
})
